// pages/NhaVuon/NhaO2Tang/index.tsx
// Trang Nhà Vườn 2 Tầng — CLEAN

import { useState } from 'react'
import { PageHero, ProjectGrid, CtaSection, Pagination } from '../../../../components'
import { useProjects } from '../../../../features/projects/hooks/useProjects'
import { nhaVuon2TangProjects } from '../../../../data/nhaVuonProjects'
import useDocumentTitle from '../../../../hooks/useDocumentTitle'
import './NhaO2Tang.css'

const BREADCRUMBS = [
  { label: 'Trang chủ', path: '/' },
  { label: 'Công trình thiết kế', path: '/cong-trinh-thiet-ke' },
  { label: 'Nhà vườn', path: '/nha-vuon' },
  { label: 'Nhà 2 tầng' },
]

const NhaVuon2TangPage = () => {
  useDocumentTitle('Nhà Vườn 2 Tầng - MAXCONST')
  
  useState(() => {
    try {
      sessionStorage.setItem('lastVisitedList', '/nha-vuon/2-tang')
      sessionStorage.setItem('lastVisitedListName', 'Nhà vườn 2 tầng')
    } catch (e) {
      // ignore
    }
  })

  const {
    currentProjects,
    loading,
    error,
    currentPage,
    totalPages,
    totalCount,
    startIndex,
    endIndex,
    setCurrentPage,
    goToNextPage,
    goToPrevPage,
    getPageNumbers,
  } = useProjects({
    category: '2tang',
    pages: 10,
  })

  return (
    <div className="nha-vuon-2tang-page">
      {/* Hero */}
      <PageHero
        tag="Thiết Kế Nhà Vườn"
        title="Nhà Vườn 2 Tầng"
        description="Mẫu nhà vườn 2 tầng hiện đại, tối ưu không gian, kết hợp hài hòa giữa thiên nhiên và kiến trúc đương đại"
        breadcrumbs={BREADCRUMBS}
        stats={
          totalCount > 0
            ? [
                { number: `${totalCount}+`, label: 'Mẫu thiết kế' },
                { number: '2', label: 'Tầng' },
                { number: '100%', label: 'Tùy chỉnh theo yêu cầu' },
              ]
            : undefined
        }
      />

      {/* Content */}
      <div className="container section">
        <ProjectGrid
          projects={currentProjects}
          loading={loading}
          error={error}
        />

        {!loading && !error && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalCount={totalCount}
            startIndex={startIndex}
            endIndex={endIndex}
            getPageNumbers={getPageNumbers}
            onPageChange={setCurrentPage}
            onPrev={goToPrevPage}
            onNext={goToNextPage}
          />
        )}

        <CtaSection
          title="Bạn Quan Tâm Đến Nhà 2 Tầng?"
          description="Liên hệ ngay để được tư vấn miễn phí về thiết kế và báo giá"
        />
      </div>
    </div>
  )
}

export default NhaVuon2TangPage
